var map = {
	"./icons/cart.svg": 72,
	"./icons/cog.svg": 35,
	"./icons/download.svg": 326,
	"./icons/grid.svg": 494,
	"./icons/inf.svg": 811,
	"./icons/info.svg": 790,
	"./icons/jpg.svg": 199,
	"./icons/mail.svg": 515,
	"./icons/minus.svg": 98,
	"./icons/paintbrush.svg": 530,
	"./icons/pdf.svg": 256,
	"./icons/plus.svg": 954,
	"./icons/redo.svg": 702,
	"./icons/share.svg": 59,
	"./icons/sharing.svg": 726,
	"./icons/shuffle.svg": 233,
	"./icons/spcfk.svg": 403,
	"./icons/undo.svg": 928,
	"./icons/youtube.svg": 325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 844;